<table class="static-table" style=width:100%; border=1
    style="border-collapse: separate;width:100% !important;border-color: #8DC63F;border-spacing: 0px;border:0px">
    <tr>
        <td style="width:150px; max-width: 150px;min-width: 150px;text-align:center;" height=150px width=150px rowspan=3>
            <img *ngIf="cutsheet?.millstandard[0] && cutsheet?.millstandard[0].images && cutsheet?.millstandard[0].images.length > 0; else noimage" width="150px" [src]="cutsheet?.millstandard[0].images[0]" alt="" srcset="">
        </td>
        <td style="padding: 0px !important;" height=50px width=50px>
            <div class="h-100">
                <div
                    style="text-transform: uppercase;height: 18px;background: #8DC63F;color: white; text-align: center ;font-size: 12px !important;">
                    height</div>
                <div style="color: #444;" class="font-condensed fs-30 text-center">{{cutsheet?.millstandard[0]?.height}}</div>
            </div>
        </td>
        <td class="fs-26">{{cutsheet?.name}}</td>
        <td class="p-0" style="border: 0px !important; height:1px;" rowspan=3>
            <table class="child-tbl font-condensed fs-20" style=width:100%;height:100% border=1>
                <tr>
                    <td>
                        <table class="w-100 mini-table">
                            <tr>
                                <td class="utility-code red">
                                    <span class="box">A</span>
                                </td>
                                <td style="border: none !important">Plumbing</td>
                            </tr>
                        </table>
                    </td>
                    <td width=30px style="text-align:center">{{cutsheet?.millstandard[0].utility_A ? 'YES' : 'NO'}}</td>
                </tr>
                <tr>
                    <td>
                        <table class="w-100 mini-table">
                            <tr>
                                <td class="utility-code orange">
                                    <span class="box">B</span>
                                </td>
                                <td style="border: none !important">Electrical</td>
                            </tr>
                        </table>
                    </td>
                    <td width=30px style="text-align:center">{{cutsheet?.millstandard[0].utility_B ? 'YES' : 'NO'}}</td>
                </tr>
                <tr>
                    <td>
                        <table class="w-100 mini-table">
                            <tr>
                                <td class="utility-code tan">
                                    <span class="box">C</span>
                                </td>
                                <td style="border: none !important">Dedicated Circuit</td>
                            </tr>
                        </table>
                    </td>
                    <td width=30px style="text-align:center">{{cutsheet?.millstandard[0].utility_C ? 'YES' : 'NO'}}</td>
                </tr>
                <tr>
                    <td>
                        <table class="w-100 mini-table">
                            <tr>
                                <td class="utility-code skin">
                                    <span class="box">D</span>
                                </td>
                                <td style="border: none !important">Emergency Power</td>
                            </tr>
                        </table>
                    </td>
                    <td width=30px style="text-align:center">{{cutsheet?.millstandard[0].utility_D ? 'YES' : 'NO'}}</td>
                </tr>
            </table>
        </td>
        <td class="p-0" style="border: 0px !important; height: 1px;" rowspan=3>

            <table class="child-tbl font-condensed fs-20" style="width:100%;height:100%" border=1>
                <tr>
                    <td>
                        <table class="w-100 mini-table">
                            <tr>
                                <td class="utility-code pink">
                                    <span class="box">E</span>
                                </td>
                                <td style="border: none !important">Comms</td>
                            </tr>
                        </table>
                    </td>
                    <td width=30px style="text-align:center">{{cutsheet?.millstandard[0].utility_E ? 'YES' : 'NO'}}</td>
                </tr>
                <tr>
                    <td>
                        <table class="w-100 mini-table">
                            <tr>
                                <td class="utility-code green">
                                    <span class="box">F</span>
                                </td>
                                <td style="border: none !important">Medical Gas</td>
                            </tr>
                        </table>
                    </td>
                    <td width=30px style="text-align:center">{{cutsheet?.millstandard[0].utility_F ? 'YES' : 'NO'}}</td>
                </tr>
                <tr>
                    <td>
                        <table class="w-100 mini-table">
                            <tr>
                                <td class="utility-code blue">
                                    <span class="box">G</span>
                                </td>
                                <td style="border: none !important">Miscellaneous Gas</td>
                            </tr>
                        </table>
                    </td>
                    <td width=30px style="text-align:center">{{cutsheet?.millstandard[0].utility_G ? 'YES' : 'NO'}}</td>
                </tr>
                <tr>
                    <td>
                        <table class="w-100 mini-table">
                            <tr>
                                <td class="utility-code purple">
                                    <span class="box">H</span>
                                </td>
                                <td style="border: none !important">Non-Medical Gas</td>
                            </tr>
                        </table>
                    </td>
                    <td width=30px style="text-align:center">{{cutsheet?.millstandard[0].utility_H ? 'YES' : 'NO'}}</td>
                </tr>
            </table>

        </td>
    </tr>
    <tr>
        <td style="padding: 0px !important;" height=50px width=50px>
            <div class="h-100">
                <div
                    style="text-transform: uppercase;height: 18px;background: #8DC63F;color: white; text-align: center ;font-size: 12px !important;">
                    width</div>
                <div style="color: #444;" class="font-condensed fs-30 text-center">{{cutsheet?.millstandard[0]?.width}}</div>
            </div>
        </td>
        <td rowspan=2 width=350px class="text-uppercase">
            <span title="{{cutsheet?.millstandard[0]?.description}}" class="line-clamp">
                {{cutsheet?.millstandard[0]?.description || 'N/A'}}
            </span>
        </td>
    </tr>
    <tr>
        <td style="padding: 0px !important;" height=50px width=50px>
            <div class="h-100">
                <div
                    style="text-transform: uppercase;height: 18px;background: #8DC63F;color: white; text-align: center ;font-size: 12px !important;">
                    depth</div>
                <div style="color: #444;" class="font-condensed fs-30 text-center">{{cutsheet?.millstandard[0]?.depth}}</div>
            </div>
        </td>
    </tr>
</table>
<ng-template #noimage>
    NO IMAGE                                                      
</ng-template>